import { TimeslotOrderGroupModel } from '@merchant-clients/order';

import { OrdersSortField } from '../order-sort.model';
import { sortOrders } from './sort-orders-by-verification';

export function sortTimeslotGroups(
  groups: TimeslotOrderGroupModel[],
  sortField: OrdersSortField,
  sortDirection: 'ASC' | 'DESC',
): TimeslotOrderGroupModel[] {
  return groups.map((group) => ({
    ...group,
    orders: sortOrders(group.orders, sortField, sortDirection),
  }));
}
